module.exports = __webpack_public_path__ + "static/media/project2.f6d7b67a.jpg";